var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-container"},[_c('PlainNavbar'),_c('div',{staticClass:"content"},[_c('h1',{staticClass:"header-title"},[_vm._v("Appointment Details")]),_c('ApptDetailPublic',{attrs:{"appt":_vm.markdoneData,"apptState":_vm.apptState,"qrcode":_vm.qrcode}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }